import $ from "jquery";
import "slick-carousel";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import "photoswipe/style.css";
import PhotoSwipeVideoPlugin from "photoswipe-video-plugin";

$(() => {
  let form = $("form.variations_form");
  let variationFormObj = false;

  // click first option for color
  if ($("select#pa_colore-oro").length) {
    $("select#pa_colore-oro option:eq(1)").prop('selected', true);
  }

  initPhotoSwipe();

  form.on("wc_variation_form", function (event, variationForm) {
    variationFormObj = variationForm;

    // fix for pre-selected data
    form.trigger("update_variation_values");

    $("#toSecondStepBtn").trigger("check_to_second_step_btn");
  });

  form.on("update_variation_values", function (event) {
    if (!variationFormObj) {
      return;
    }

    // fix: check on active step for gallery update (don't do it from step 2)
    const currentStep = $("li.variations-tab.current");
    if (currentStep.length == 0) {
      // check for slick on normal products
      window.setTimeout(function () {
        updateMobileGallery(variationFormObj);
      }, 20);
      return;
    }
    if (currentStep.attr("id") !== "firstStepTab") {
      return;
    }

    // Need a delay to skip the initial reset image when no variation image is set
    window.setTimeout(function () {
      updateGallery(variationFormObj);
    }, 20);
  });

  // simple products form
  const simpleProductForm = $("form.cart:not(.variations_form)");

  if (simpleProductForm && form.length === 0) {
    window.setTimeout(function () {
      updateMobileGallery(simpleProductForm, true);
    }, 20);
  }

  // hide do not know option for ring size select
  $('select#pa_taglia-anello option[value="do-not-know"]').hide();

  // all the logic for the engagement rings multi step tabs are here
  manageTabs();

  // manage carats custom attribute
  manageCaratsAttribute();

  // $('ul[data-attribute_name="attribute_pa_forma-diamante"] > :first-child').click();

  // manage ring size custom attribute
  manageSizeRadio();

  // Variation price change
  manageVariationPrice();

  // manage mini cart
  manageAjaxAddToCart();
  manageAjaxRemoveFromCart();

  handleMiniCart();

  // manage mini cart for workshop products
  handleAjaxWorkshops();

  //initPhotoSwipe();
});

function handleMiniCart() {
  const closeBtn = document.querySelector(
    "#groot-mini-cart-wrapper #close-btn"
  );

  if (!closeBtn) return;

  closeBtn.addEventListener("click", function (e) {
    document
      .querySelector("#groot-mini-cart_aside")
      .classList.add("translate-x-full");

    setTimeout(() => {
      document
        .querySelector("#groot-mini-cart-wrapper")
        .classList.add("hidden");
    }, 600);
  });

  // close by clicking out of cart
  $("#groot-outer-cart").on("click", function (e) {
    document
      .querySelector("#groot-mini-cart_aside")
      .classList.add("translate-x-full");

    setTimeout(() => {
      document
        .querySelector("#groot-mini-cart-wrapper")
        .classList.add("hidden");
    }, 600);
  });
}

function updateGallery(form) {
  let customVariantsGallery = $("#custom-variants-gallery");

  const chosenAttributes = form.getChosenAttributes();

  if (chosenAttributes.count <= 1) {
    return;
  }

  /*if (!form.variationData) {
    form.variationData = ajaxObject.variations;
  }*/

  let res = form.findMatchingVariations(
    form.variationData,
    chosenAttributes.data
  );
  if (
    res.length > 0 &&
    chosenAttributes.chosenCount > 0 &&
    chosenAttributes.chosenCount < chosenAttributes.count
  ) {
    const ajaxLoading = $("#ajax-loading");
    $.ajax({
      url: ajaxObject.url,
      method: "post",
      dataType: "json",
      data: {
        action: "product_gallery",
        _nonce: ajaxObject._nonce,
        postId: ajaxObject.postId,
        attributes: chosenAttributes.data,
      },
      beforeSend: function () {
        ajaxLoading.removeClass("hidden");
      },
      success: function (response) {
        if (response.success) {
          ajaxLoading.addClass("hidden");
          if (response.data.gallery) {
            customVariantsGallery.empty();
            customVariantsGallery.removeClass("slick-initialized");
            customVariantsGallery.append(response.data.gallery);
            bindSingleProductSlider();
            initPhotoSwipe();
          }
        }
      },
      error: function () {
        ajaxLoading.addClass("hidden");
        console.log("ERROR!");
      },
    });
  }
}

function manageTabs() {
  const firstStepTab = $("#firstStepTab");
  const secondStepTab = $("#secondStepTab");
  const thirdStepTab = $("#thirdStepTab");

  if (!firstStepTab || !secondStepTab || !thirdStepTab) {
    return;
  }

  // First step attributes
  const colorAttribute = $('*[data-attribute_name="attribute_pa_colore-oro"]');
  const shapeAttribute = $(
    '*[data-attribute_name="attribute_pa_forma-diamante"]'
  );

  // Second step attributes
  const caratAttribute = $(
    '*[data-attribute_name="attribute_pa_range-carature"]'
  );
  const caratTypeAttribute = $(
    '*[data-attribute_name="attribute_pa_caratura-diamante"]'
  );

  // Third step attributes
  const sizeAttribute = $(
    '*[data-attribute_name="attribute_pa_taglia-anello"]'
  );
  const dedication = $('*[data-attribute_name="custom_dedication"]');

  // Buttons
  const toSecondStepBtn = $("#toSecondStepBtn");
  const toThirdStepBtn = $("#toThirdStepBtn");
  const addToCartBtn = $("#addToCartBtn");

  // basic settings
  toSecondStepBtn.attr("disabled", true);
  toThirdStepBtn.attr("disabled", true);

  // Disable normal click for custom btn
  toSecondStepBtn.on("click", function (e) {
    e.preventDefault();
    completeStep(firstStepTab);
    toggleActive(secondStepTab);
    $('*[data-attribute_name="attribute_pa_forma-diamante"]').trigger('change');
    secondStepTab.trigger("click");
  });
  toThirdStepBtn.on("click", function (e) {
    e.preventDefault();
    completeStep(secondStepTab);
    toggleActive(thirdStepTab);

    // empty ring size attribute
    $("select#pa_taglia-anello").val("").change();

    thirdStepTab.trigger("click");
  });

  // First tab on click
  firstStepTab.on("click", function () {
    colorAttribute.show();
    shapeAttribute.show();
    caratAttribute.hide();
    caratTypeAttribute.hide();
    sizeAttribute.hide();
    dedication.hide();
    // set current
    setCurrentTab(firstStepTab);
    // active
    toggleActive(firstStepTab);
    toggleDeactive(secondStepTab);
    toggleDeactive(thirdStepTab);
    // btn
    toSecondStepBtn.show();
    toThirdStepBtn.hide();
    addToCartBtn.hide();
  });

  // Second tab on click
  secondStepTab.on("click", function () {
    if ($(this).hasClass("deactivated")) {
      return;
    }
    colorAttribute.hide();
    shapeAttribute.hide();
    caratAttribute.show();
    caratTypeAttribute.show();
    sizeAttribute.hide();
    dedication.hide();
    // set current
    setCurrentTab(secondStepTab);
    // active
    toggleActive(firstStepTab);
    toggleActive(secondStepTab);
    toggleDeactive(thirdStepTab);
    // btn
    toSecondStepBtn.hide();
    toThirdStepBtn.show();
    addToCartBtn.hide();
  });

  // Third tab on click
  thirdStepTab.on("click", function () {
    if ($(this).hasClass("deactivated")) {
      return;
    }
    colorAttribute.hide();
    shapeAttribute.hide();
    caratAttribute.hide();
    caratTypeAttribute.hide();
    sizeAttribute.show();
    dedication.show();
    // set current
    setCurrentTab(thirdStepTab);
    // active
    toggleActive(firstStepTab);
    toggleActive(secondStepTab);
    toggleActive(thirdStepTab);
    // btn
    toSecondStepBtn.hide();
    toThirdStepBtn.hide();
    addToCartBtn.show();
  });

  // trigger click on first step tab
  firstStepTab.trigger("click");

  // Manage first step
  $("select#pa_colore-oro").on("change", function () {
    toSecondStepBtn.trigger("check_to_second_step_btn");
  });
  $("select#pa_forma-diamante").on("change", function () {
    toSecondStepBtn.trigger("check_to_second_step_btn");
  });
  toSecondStepBtn.on("check_to_second_step_btn", function () {
    const colorValue = $("select#pa_colore-oro").val();
    const shapeValue = $("select#pa_forma-diamante").val();

    if (colorValue !== "" && shapeValue !== "") {
      toSecondStepBtn.attr("disabled", false);
      toSecondStepBtn.removeClass("disabled");
    } else {
      toSecondStepBtn.attr("disabled", true);
      toSecondStepBtn.addClass("disabled");
    }
  });

  // Manage second step
  $("select#pa_range-carature").on("change", function () {
    toThirdStepBtn.trigger("check_to_third_step_btn");
  });
  $("select#pa_caratura-diamante").on("change", function () {
    toThirdStepBtn.trigger("check_to_third_step_btn");
  });
  toThirdStepBtn.on("check_to_third_step_btn", function () {
    const rangeValue = $("select#pa_range-carature").val();
    const caratValue = $("select#pa_caratura-diamante").val();

    if (rangeValue !== "" && caratValue !== "") {
      $(this).attr("disabled", false);
      $(this).removeClass("disabled");
    } else {
      $(this).attr("disabled", true);
      $(this).addClass("disabled");
    }
  });

  // Manage third step
  $('input[name="pa_taglia-anello_custom"]').on("change", function () {
    if ($("input#not-know").is(":checked")) {
      completeStep(thirdStepTab);
    }
  });
  $("select#pa_taglia-anello").on("change", function () {
    if ($(this).val() !== "") {
      completeStep(thirdStepTab);
    } else {
      resetStep(thirdStepTab);
    }
  });

  // Reset button
  $(".reset_variations").on("click", function () {
    resetStep(firstStepTab);
    resetStep(secondStepTab);
    resetStep(thirdStepTab);
    // empty price
    $("#toThirdStepBtn").find("span.variation-price").empty();
    $("#addToCartBtn").find("span.variation-price").empty();
    // empty size radio button (and hide select)
    $('input[name="pa_taglia-anello_custom"]').prop("checked", false);
    $("#pa_taglia-anello_wrapper").hide();

    // trigger the first step
    firstStepTab.trigger("click");
  });
}

function toggleActive(element) {
  if (!element.hasClass("active")) {
    element.addClass("active");
  }
  if (element.hasClass("deactivated")) {
    element.removeClass("deactivated");
  }
}

function toggleDeactive(element) {
  if (element.hasClass("active")) {
    element.removeClass("active");
  }
  if (element.hasClass("completed")) {
    return;
  }
  if (!element.hasClass("deactivated")) {
    element.addClass("deactivated");
  }
}

function setCurrentTab(element) {
  $("li.variations-tab").removeClass("current");
  element.addClass("current");
}

function bindSingleProductSlider() {
  if (window.innerWidth < 1024) {
    const slickWrappers = document.querySelectorAll(".single-product-slick");

    slickWrappers.forEach((wrapper) => {
      const slick = wrapper.querySelector(".slick");

      $(slick).not(".slick-initialized").slick({
        dots: true,
        fade: false,
        swipe: true,
        arrows: false,
        centerMode: true,
      });
    });
  }
}

function manageCaratsAttribute() {
  const shapeAttribute = $(
    '*[data-attribute_name="attribute_pa_forma-diamante"]'
  );
  const caratAttribute = $(
    '*[data-attribute_name="attribute_pa_range-carature"]'
  );
  const caratTypeSelect = $("select#pa_caratura-diamante");

  shapeAttribute.on("change", function () {
    window.setTimeout(function () {
      caratTypeSelect.trigger("change_option_values");
    }, 20);
  });
  caratAttribute.on("change", function () {
    window.setTimeout(function () {
      caratTypeSelect.trigger("change_option_values");
    }, 20);
  });

  caratTypeSelect.on("change_option_values", function () {
    const caratTypeSelectOptions = caratTypeSelect.find("option.enabled");
    $("#pa_caratura-diamante_custom > .custom-option").hide();
    caratTypeSelectOptions.each(function () {
      $("#pa_caratura-diamante_custom")
        .find('.custom-option[data-slug="' + this.value + '"]')
        .show();
    });
  });

  $("#pa_caratura-diamante_custom .custom-option").on("click", function () {
    const optionSelected = $(this).attr("data-slug");
    const actualValue = $("select#pa_caratura-diamante").val();
    $("#pa_caratura-diamante_custom .custom-option").removeClass("border-2");
    if (optionSelected != actualValue) {
      $(this).addClass("border-2");
      $(
        'select#pa_caratura-diamante option[value="' + optionSelected + '"]'
      ).prop("selected", true);
    } else {
      $('select#pa_caratura-diamante option[value=""]').prop("selected", true);
    }
    caratTypeSelect.trigger("change");

    // fix
    if ($("select#pa_caratura-diamante").val() === "") {
      $('select#pa_range-carature option[value=""]').prop("selected", true);
    } else {
      $("select#pa_range-carature option:last").prop("selected", true);
    }
    $("select#pa_range-carature").trigger("change");
  });

  $("select#pa_range-carature").on("change", function () {
    const optionSelected = $(this).val();
    if (optionSelected === "") {
      $('select#pa_caratura-diamante option[value=""]').prop("selected", true);
      $("#pa_caratura-diamante_custom .custom-option").removeClass("border-2");
      $("select#pa_caratura-diamante").trigger("change");
    }
  });
}

function completeStep(step) {
  step.find(".step-completed").removeClass("hidden");
  step.find(".step-number").addClass("hidden");
  if (!step.hasClass("completed")) {
    step.addClass("completed");
  }
}

function resetStep(step) {
  step.find(".step-completed").addClass("hidden");
  step.find(".step-number").removeClass("hidden");
}

function manageSizeRadio() {
  const sizeRadioButtons = $('input[name="pa_taglia-anello_custom"]');
  const sizeWrapper = $("#pa_taglia-anello_wrapper");
  const sizeSelect = $("select#pa_taglia-anello");

  sizeRadioButtons.on("click", function () {
    if ($("#know").is(":checked")) {
      sizeWrapper.show();
      $("input#add_ring_sizer").val("0");
    } else {
      sizeWrapper.hide();
      $("input#add_ring_sizer").val("1");
      sizeSelect.val("do-not-know").change();
    }
  });
}

function manageVariationPrice() {
  $(".single_variation_wrap").change(function () {
    const variationPrice = $(".single_variation_wrap .woocommerce-variation-price");
    const variationPriceText = variationPrice.text();
    const addToCartVariationPrice = $("#addToCartBtn").find("span.variation-price");
    const toThirdStepVariationPrice = $('#toThirdStepBtn').find('span.variation-price');
    if (variationPrice.length && variationPriceText != "") {
      // change add to cart button
      addToCartVariationPrice.empty();
      addToCartVariationPrice.html("- " + variationPriceText);
      // change toThirdStep button
      toThirdStepVariationPrice.empty();
      toThirdStepVariationPrice.html("- " + variationPriceText);
    }
  });
}

/**
 * Manage custom add to cart via ajax.
 */
function manageAjaxAddToCart() {
  $(document).on("click", "#addToCartBtn:not(.disabled)", function (e) {
    e.preventDefault();

    // return if disabled
    if ($("#addToCartBtn").hasClass("disabled")) {
      return;
    }

    const cartForm = $("form.cart");

    let data = [];
    data["action"] = "groot_add_to_cart";
    data["_nonce"] = ajaxObject._nonce;
    data["product_id"] = ajaxObject.postId;
    data["product_sku"] = "";
    data["quantity"] = 1;

    const formData = cartForm.serializeArray();
    formData.forEach(function (item) {
      data[item["name"]] = item["value"];
    });
    const dataObject = Object.assign({}, data);

    cartForm.block({
      message: null,
      overlayCSS: { background: "#fff", opacity: 0.6 },
    });

    $.ajax({
      url: ajaxObject.url,
      method: "POST",
      dataType: "json",
      data: dataObject,
      beforeSend: function (response) {
        $("#addToCartBtn").removeClass("added").addClass("loading");
      },
      complete: function (response) {
        $("#addToCartBtn").addClass("added").removeClass("loading");
        cartForm.unblock();
      },
      success: function (response) {
        //$(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $('#addToCartBtn')]);
        $(document.body).trigger("wc_fragment_refresh");

        // show custom mini cart
        $("#groot-mini-cart-wrapper").removeClass("hidden");

        setTimeout(function () {
          $("#groot-mini-cart_aside").removeClass("translate-x-full");
          $("#groot-mini-cart").block({
            message: null,
            overlayCSS: { background: "#fff", opacity: 0.6 },
          });
        }, 0);
      },
      error: function () {
        console.log("ERROR!");
      },
    });
  });
}

/**
 * Manage custom remove from cart via ajax.
 */
function manageAjaxRemoveFromCart() {
  $(document).on("click", ".groot-remove-from-mini-cart", function (e) {
    e.preventDefault();
    const grootMiniCart = $('ul.woocommerce-mini-cart');

    let data = [];
    data["action"] = "groot_remove_from_cart";
    data["_nonce"] = ajaxObject._nonce;
    data["cart_item_key"] = $(this).attr('data-cart-item-key');

    const dataObject = Object.assign({}, data);

    grootMiniCart.block({
      message: null,
      overlayCSS: { background: "#fff", opacity: 0.6 },
    });

    $.ajax({
      url: ajaxObject.url,
      method: "POST",
      dataType: "json",
      data: dataObject,
      complete: function (response) {
        grootMiniCart.unblock();
      },
      success: function (response) {
        //$(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $('#addToCartBtn')]);
        $(document.body).trigger("wc_fragment_refresh");

        setTimeout(function () {
          $("#groot-mini-cart").block({
            message: null,
            overlayCSS: { background: "#fff", opacity: 0.6 },
          });
        }, 0);
      },
      error: function () {
        console.log("ERROR!");
      },
    });
  });
}

function initPhotoSwipe() {
  const lightbox = new PhotoSwipeLightbox({
    gallery: ".woocommerce-product-gallery",
    children: "div:not(.slick-cloned) a",
    pswpModule: () => import("photoswipe"),
    bgOpacity: 1,
    counter: false,
    showHideAnimationType: "none",
    zoomAnimationDuration: false,
    allowPanToNext: false,
    allowMouseDrag: false,
    wheelToZoom: true,
    zoom: false,
  });

  const videoPlugin = new PhotoSwipeVideoPlugin(lightbox);

  lightbox.init();
}

/**
 * Change variation product images on mobile for other than engagement rings.
 */
function updateMobileGallery(form, isSimpleForm = false)
{
  /*
  if (window.innerWidth >= 1024) {
    return;
  }
  */
  let res = [];
  if (!isSimpleForm) {
    const chosenAttributes = form.getChosenAttributes();

    /*
    if (chosenAttributes.count <= 1) {
      return;
    }
    */
    res = form.findMatchingVariations(
      form.variationData,
      chosenAttributes.data
    );
  }

  if (res.length == 1 || isSimpleForm) {
    const ajaxLoading = $("#ajax-loading");
    const gallery = $('#custom-gallery');

    $.ajax({
      url: ajaxObject.url,
      method: "post",
      dataType: "json",
      data: {
        action: "change_slick_gallery_variation",
        _nonce: ajaxObject._nonce,
        postId: ajaxObject.postId,
        imageId: (isSimpleForm) ? 0 : res[0].image_id
      },
      beforeSend: function () {
        ajaxLoading.removeClass("hidden");
      },
      success: function (response) {
        if (response.success) {
          ajaxLoading.addClass("hidden");
          if (response.data.gallery) {
            gallery.empty();
            gallery.removeClass("slick-initialized");
            gallery.append(response.data.gallery);
            bindSingleProductSlider();
            initPhotoSwipe();
          }
        } else {
          ajaxLoading.addClass("hidden");
        }
      },
      error: function () {
        ajaxLoading.addClass("hidden");
        console.log("ERROR!");
      },
    });
  }
}

function handleAjaxWorkshops()
{
  $(document).on("click", "#singleAddToCart:not(.disabled)", function (e) {
    e.preventDefault();

    // return if disabled
    if ($("#singleAddToCart").hasClass("disabled")) {
      return;
    }

    const cartForm = $("form.cart");

    let data = [];
    data["action"] = "groot_add_to_cart";
    data["_nonce"] = ajaxObject._nonce;
    data["product_id"] = ajaxObject.postId;
    data["product_sku"] = "";
    data["quantity"] = 1;

    const formData = cartForm.serializeArray();
    formData.forEach(function (item) {
      data[item["name"]] = item["value"];
    });
    const dataObject = Object.assign({}, data);

    cartForm.block({
      message: null,
      overlayCSS: { background: "#fff", opacity: 0.6 },
    });

    $.ajax({
      url: ajaxObject.url,
      method: "POST",
      dataType: "json",
      data: dataObject,
      beforeSend: function (response) {
        $("#singleAddToCart").removeClass("added").addClass("loading");
      },
      complete: function (response) {
        $("#singleAddToCart").addClass("added").removeClass("loading");
        cartForm.unblock();
      },
      success: function (response) {
        //$(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $('#singleAddToCart')]);
        $(document.body).trigger("wc_fragment_refresh");

        // show custom mini cart
        $("#groot-mini-cart-wrapper").removeClass("hidden");

        setTimeout(function () {
          $("#groot-mini-cart_aside").removeClass("translate-x-full");
          $("#groot-mini-cart").block({
            message: null,
            overlayCSS: { background: "#fff", opacity: 0.6 },
          });
        }, 0);
      },
      error: function () {
        console.log("ERROR!");
      },
    });
  });
}
